<template>
  <div class="is-main-content">
    <div class="columns">
      <b-collapse class="is-pulled-left is-sidebar-menu" :open="isOpen"
        v-bind:class="{'isCloseSidebar': !isOpen}">
        <aside class="menu">
          <app-filter/>
        </aside>
      </b-collapse>
      <a class="button collapse_btn" @click="isOpen = !isOpen">
        <b-icon class="icon_collapse"
                :icon="isOpen ? 'chevron-left' : 'chevron-right'">
        </b-icon>
      </a>
      <div class="column">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="">Vente Réseaux Lc</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">

            <div class="is-pulled-right client">
              <app-client :disabled="true"/>
            </div>
            <div class="is-pulled-right">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="showReseauxSelectionne"
                  @input="checkboxFiltres()">
                  Réseaux selectionnés
                </b-checkbox>
              </div>
            </div>
            <div class="positionBntExport">
              <app-export-excel v-if="activeTab === 1" :liste="dataListe"/>
            </div>
            <div class="positionAzimut">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="afficherAzimut"
                  @input="checkboxAzimut()">
                  Azimut
                </b-checkbox>
              </div>
            </div>
            <b-tabs type="is-toggle" v-model="activeTab">
              <b-tab-item :label="carteLibelle" icon="google-maps">
                <app-carte v-if="showReseauxLc"/>
              </b-tab-item>
              <b-tab-item :label="listeLibelle" icon="format-list-bulleted">
                <app-liste v-on:liste="chargeListe($event)" v-if="showReseauxLc"/>
              </b-tab-item>
              <b-tab-item :label="planningLibelle" icon="calendar-text">
                <app-planning v-if="showReseauxLc"/>
              </b-tab-item>
            </b-tabs>
            <div v-if="!showReseauxLc">
              <div>
                <div class="hero">
                  <div class="section">
                    <div class="hero-body">
                      <h1 class="title is-1 has-text-centered">Commencer votre recherche</h1>
                      <div class="content">
                        <h3 class="has-text-centered">
                          Utilisez les filtres à gauche de l'écran pour effectuer votre recherche.
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import * as typesUser from '@/store/modules/user-mutation-type';
import * as sizesGetter from '@/services/general/sizeScreenGetter';
import ExportExcel from '@/components/creationOpportunite/exportExcel';
import Filter from './filtres/filtre';
import Liste from './recherche/liste';
import Planning from './recherche/planning';
import Carte from './recherche/carte';
import client from '../panier/client/client';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const User = createNamespacedHelpers('user');
const VALEUR_FILTRE_SELECTED = 'selected';

export default {
  name: 'page',
  data() {
    return {
      isOpen: true,
      dataListe: [],
    };
  },
  components: {
    appFilter: Filter,
    appListe: Liste,
    appCarte: Carte,
    appClient: client,
    appPlanning: Planning,
    appExportExcel: ExportExcel,
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      showReseauxLc: 'showReseauxLc',
      getshowReseauxSelectionne: 'showReseauxSelectionne',
      getActiveTabReseau: 'activeTabReseau',
    }),
    ...User.mapGetters({
      getAfficherAzimut: 'afficherAzimut',
    }),
    showReseauxSelectionne: {
      get() {
        return this.getshowReseauxSelectionne;
      },
      set(value) {
        this.setShowReseauxSelectionne(value);
      },
    },
    afficherAzimut: {
      get() {
        return this.getAfficherAzimut;
      },
      set(value) {
        this.setAfficherAzimut(value);
      },
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    carteLibelle() {
      return sizesGetter.isTablet() ? '' : 'Carte';
    },
    listeLibelle() {
      return sizesGetter.isTablet() ? '' : 'Liste';
    },
    planningLibelle() {
      return sizesGetter.isTablet() ? '' : 'Planning';
    },
  },
  methods: {
    ...VenteReseauxLc.mapMutations({
      setShowReseauxSelectionne: types.SET_SHOW_RESEAUX_SELECTIONNE,
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
      setRemoveFilterProperty: types.REMOVE_FILTER_PROPERTY,
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
    }),
    ...User.mapMutations({
      setAfficherAzimut: typesUser.SET_AZIMUT,
    }),
    ...VenteReseauxLc.mapActions({
      actionsRechercheReseauxLc: 'rechercheReseauxLc',
      actionsGestionFiltresVentesReseaux: 'gestionFiltresVentesReseaux',
      actionsUpdateMarkerReseauLc: 'updateMarkerReseauLc',
    }),
    checkboxFiltres() {
      const valeursFilter = [];
      if (this.showReseauxSelectionne) {
        valeursFilter.push(this.showReseauxSelectionne);
      } else {
        valeursFilter.splice(this.showReseauxSelectionne, 1);
      }
      this.setAddFilterProperty(
        { property: VALEUR_FILTRE_SELECTED,
          valueProperty: { variable: VALEUR_FILTRE_SELECTED, valeur: valeursFilter } });
      this.actionsGestionFiltresVentesReseaux();
    },
    checkboxAzimut() {
      this.actionsUpdateMarkerReseauLc();
    },
    chargeListe(data) {
      this.dataListe = data;
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: null });
    this.actionsRechercheReseauxLc().then(() => {
      loadingComponent.close();
    }).catch((e) => {
      loadingComponent.close();
      gestionErreur('Erreur lors de la récupération des réseaux LC', e);
    });
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/index.vue